import { CatalystInsight } from '@api';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { CatalystInsightIcon } from '@terminal/widgets/catalyst-insights-drawer/catalyst-insight-icon/CatalystInsightIcon';
import { useCatalystDrawer } from '@terminal/widgets/catalyst-insights-drawer/useCatalystDrawer';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CompanyCatalystCounterTooltip.module.scss';

interface CompanyCatalystCounterTooltipProps {
  insights: CatalystInsight[];
  source: PosthogTrackingSource;
  onClose?: () => void;
}

export const CompanyCatalystCounterTooltip = ({
  insights,
  source,
  onClose,
}: CompanyCatalystCounterTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();

  return (
    <div onClick={e => e.stopPropagation()}>
      {insights.map(insight => {
        const entityTag = insight.identifier;

        return (
          <div
            key={insight.id}
            className={styles.tooltipWrapper}
            onClick={() => {
              if (entityTag) {
                openDrawer({
                  type: 'company',
                  entityTag,
                  insightId: insight.id,
                  source,
                });
                onClose?.();
              }
            }}
          >
            <CatalystInsightIcon
              catalystInsightId={insight.id}
              category={insight.category}
              subCategory={insight.sub_category}
              size={32}
              enableHover={false}
              isBordered
              identifier={entityTag}
              source={source}
              isDisabled={false}
              isClickable={false}
            />
            <div className={styles.rightWrapper}>
              <span className={styles.tooltipTitleLabel}>
                {t('insights:catalyst.titleCompanyCatalyst')}
              </span>
              <p className={styles.categoryLabel}>
                {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */}
                {insight.sub_category
                  ? t(`catalyst.subcategories.${insight.sub_category}`)
                  : null}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
